/*
 * @Author: zfd
 * @Date: 2020-09-06 10:08:57
 * @LastEditTime: 2020-09-06 18:50:11
 * @Description: 
 * @FilePath: \trip-enterprise\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { hasLogined, removeToken } from './common/auth'

import router from './router'
import store from './store'
// import './common/vee-validator'//引入vee-validator校验插件（推荐局部注册）
// import util from './common/utils'
import './assets/css/reset.css'
// import 'assets/css/main.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
import VueCropper from 'vue-cropper'
Vue.use(VueCropper)

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios, axios);

// import md5 from 'js-md5';
// Vue.prototype.$md5 = md5;

// import sha1 from 'js-sha1'
// Vue.prototype.$sha1 = sha1;

router.beforeEach((to, from, next) => {
  
  if(to.path=="/regist" || to.path=="/login")
  {
    next();
  }
  else if (to.matched.length === 0) {
    next('/error/404')
    return;
  }
  else if(hasLogined()){
    next();
  }
  else {
    removeToken()
    store.commit("user/SET_LOGIN", false);
    router.push('/login');
    next()
  }

});

var VM=new Vue({
  router,
  store,
  render: h => h(App),
  created() {
    // if (!hasLogined()) {
    //   this.$router.push({ path: "/login" });
    // }
  }
}).$mount('#app')
